import React, { useState } from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import _ from 'lodash'
import * as XLSX from "xlsx"
import moment from "moment"
import { COLOR_APP } from '../../constants'
import PaginationsV1 from '../../components/PaginationV1'

export default function SoldProductsData({ soldProducts }) {
    const [page, setPage] = useState(0);
    const rowsPerPage = 50;

    if (_.isEmpty(soldProducts)) return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
            <p>ບໍ່ມີຂໍ້ມູນ</p>
        </div>
    )

    const handleExportExcel = () => {
        try {
            const dataToExport = soldProducts.map((item, index) => ({
                "ລ/ດ": index + 1,
                "ຊື່ສິນຄ້າ": item?.productName || "ຍັງບໍ່ກໍານົດ",
                "ທັງໝົດ": item?.total || 0,
                "ຂາຍອອກ": item?.sold || 0,
                "ຍັງເຫຼືອ": item?.remaining || 0
            }));

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(dataToExport);

            // Set column widths
            const wscols = [
                { wch: 10 }, // ລ/ດ
                { wch: 40 }, // ຊື່ສິນຄ້າ
                { wch: 15 }, // ທັງໝົດ
                { wch: 15 }, // ຂາຍອອກ
                { wch: 15 }  // ຍັງເຫຼືອ
            ];
            worksheet['!cols'] = wscols;

            XLSX.utils.book_append_sheet(workbook, worksheet, "Sold Products");
            XLSX.writeFile(workbook, `ລາຍງານສິນຄ້າທີ່ຂາຍໄປ_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
        } catch (error) {
            console.error("Error exporting excel:", error);
        }
    };

    const paginatedData = soldProducts.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    const pageAll = Math.ceil(soldProducts.length / rowsPerPage);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div style={{ fontSize: '14px', color: '#666' }}>
                    ສະແດງ {page * rowsPerPage + 1} - {Math.min((page + 1) * rowsPerPage, soldProducts.length)} ຈາກ {soldProducts.length} ລາຍການ
                </div>
                <Button variant="success" onClick={handleExportExcel} style={{ fontSize: '14px' }}>
                    Export to Excel
                </Button>
            </div>
            
            <Table responsive>
                <thead style={{ background: COLOR_APP, color: "#fff" }}>
                    <tr>
                        <th>ລ/ດ</th>
                        <th>ຊື່ສິນຄ້າ</th>
                        <th>ທັງໝົດ</th>
                        <th>ຂາຍອອກ</th>
                        <th>ຍັງເຫຼືອ</th>
                    </tr>
                </thead>
                <tbody style={{ background: "#eee" }}>
                    {paginatedData.map((item, index) => (
                        <tr key={index}>
                            <td id="index">{(page * rowsPerPage) + index + 1}</td>
                            <td>{item?.productName ?? "ຍັງບໍ່ກໍານົດ"}</td>
                            <td>{item?.total ?? "0"}</td>
                            <td>{item?.sold ?? "0"}</td>
                            <td>{item?.remaining ?? "0"}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="mt-3">
                <PaginationsV1
                    count={soldProducts.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={(newPage) => setPage(newPage)}
                />
            </div>
        </div>
    )
}
